import { Component, inject } from '@angular/core';
import { DeviceService } from 'projects/max/dfup-storeupweb-fe/src/app/service/device.service';
import { I18nService } from 'shared/module/i18n/i18n.service';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  public readonly appleAppLink = 'https://apps.apple.com/cz/app/storeup/id6472715658';
  public readonly googleAppLink = 'https://play.google.com/store/apps/details?id=cz.datafriends.mymax&pcampaignid=web_share';

  public deviceSvc = inject(DeviceService);
  private i18nSvc = inject(I18nService);

  public appStoreImg: string = 'background: url(\'' +
    this.i18nSvc.translate('app.home.app-store-button') + '\')';
  public googlePlayImg: SafeResourceUrl = 'background: url(\'' +
    this.i18nSvc.translate('app.home.google-play-button') + '\')';
}
